import './select.scss';
//react
import { useEffect, useState } from 'react';
//shared
import IDataSelect from '../../interfaces/select.interface';
//material
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export const SelectMui = ({ selectData, onAction, placeholder, keySelect }: { selectData: IDataSelect, onAction: (newValue: string) => void, placeholder?: string, keySelect?: string }) => {
    const [value, changeValue] = useState<any>(selectData.value);

    useEffect(() => {
        changeValue(selectData.value);
    }, [selectData]);

    const handleChange = (event: any) => {
        changeValue(event);
    };

    if (keySelect) {
        let divElement = document.getElementById(`demo-simple-select-helper ${keySelect}`);
        if (divElement && placeholder) {
            let spanElement = divElement.querySelector('span');
            if (spanElement) spanElement.innerHTML = placeholder;
        }
    }

    return (
        <div className="select-contain" key={keySelect}>
            <FormControl className={selectData.color ? selectData.color : "Standard"}>
                {selectData.label && (
                    <InputLabel className="label">{selectData.textLabel}</InputLabel>
                )}       
                <Select
                    disabled={selectData?.disabled ? selectData?.disabled : false}
                    labelId="demo-simple-select-helper-label"
                    id={`demo-simple-select-helper ${keySelect}`}
                    value={value}
                    onChange={(newValue: SelectChangeEvent) => {
                        handleChange(newValue.target.value);
                        onAction(newValue.target.value);
                    }}
                    placeholder={placeholder ? placeholder : ''}
                    key={keySelect}
                >                    
                    {placeholder && (                        
                        <MenuItem key={'noValue'} value={''}>{placeholder}</MenuItem>
                    )}
                    {selectData.items.map((item: any) => (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}